import {useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import { useMetaTags } from '../../services/useMetaTags';
import {NavLink} from 'react-router-dom';
import '../../assets/styles/promoCodes/promoCodes.scss';

function normalizePromoCode(value) {
    const compact = (value || '').toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 8);
    const pairs = compact.match(/.{1,2}/g) || [];

    return pairs.join('-');
}

export default function ActivatePromoCodePage() {
    const {t} = useTranslation();
    const [promoCode, setPromoCode] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useMetaTags({
        title: t('promoCodes.activate.title'),
        description: t('app.description'),
        metas: [{name: 'keywords', content: t('app.keywords')}],
    });

    const canSubmit = useMemo(() => promoCode.length === 11 && !isSubmitting, [promoCode.length, isSubmitting]);

    const submitPromoCode = (event) => {
        event.preventDefault();

        if (!promoCode.trim()) {
            setErrorMessage(t('login.errors.required'));
            return;
        }

        setErrorMessage('');
        setIsSubmitting(true);

        const formData = new FormData();
        formData.append('promoCode', promoCode);

        fetch('/api/v1/promo/code/activate', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
        }).then(async (response) => {
            if (response.ok) {
                window.location.href = '/promoCodes';
                return;
            }

            if (response.status === 406) {
                setErrorMessage(t('app.promoCode.alreadyActivated'));
                return;
            }

            if (response.status === 410) {
                setErrorMessage(t('app.promoCode.contentAlreadyActivated'));
                return;
            }

            setErrorMessage(t('app.promoCode.invalidCode'));
        }).catch(() => {
            setErrorMessage(t('app.promoCode.invalidCode'));
        }).finally(() => {
            setIsSubmitting(false);
        });
    };

    return (
        <section className="promo-codes-page">
            <div className="container">
                <nav className="navigation-promo">
                    <NavLink exact to="/promoCodes" activeClassName="active" title={t('promoCodes.tabs.added')}>{t('promoCodes.tabs.added')}</NavLink>
                    <NavLink exact to="/activatePromoCode" activeClassName="active" title={t('promoCodes.tabs.activate')}>{t('promoCodes.tabs.activate')}</NavLink>
                </nav>
                <div className="form-wrap">
                    <h1>{t('promoCodes.activate.header')}</h1>
                    <form method="POST" onSubmit={submitPromoCode}>
                        <div className="activate-promo-form-block">
                            <div className="flex-baseline">
                                <div>
                                    <h6>{t('app.promoCode.enterPromo')}</h6>
                                    <input
                                        type="text"
                                        name="promoCode"
                                        placeholder="XX-XX-XX-XX"
                                        className="form-input js-promo-code"
                                        maxLength={11}
                                        value={promoCode}
                                        onChange={(event) => {
                                            setPromoCode(normalizePromoCode(event.target.value));
                                        }}
                                    />
                                </div>
                                <div className="right-align">
                                    <button type="submit" className="btn btn-activate" disabled={!canSubmit}>{t('app.promoCode.activate')}</button>
                                </div>
                            </div>
                            <div className="error-block">
                                <div className={errorMessage ? 'promo-code-error' : 'promo-code-error hidden'}>{errorMessage}</div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </section>
    );
}
